import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

// Sunucudan yetkiler gelemezse (ör. eski backend) kullanılan varsayılanlar — backend services/permissions.js ile aynı
const DEFAULT_PERMS = {
  finance: ['billing.view', 'billing.edit', 'contacts.delete_any', 'notify.billing'],
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Rol yetkileri (Ayarlar → Yetkilendirme) her açılışta ve girişte sunucudan tazelenir
  const refreshPermissions = useCallback(async () => {
    try {
      const r = await api.get('/permissions/me');
      setUser(u => {
        if (!u) return u;
        const next = { ...u, permissions: r.data.permissions || [] };
        localStorage.setItem('user', JSON.stringify(next));
        return next;
      });
    } catch (e) { /* eski backend veya oturum yok: varsayılanlar */ }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      refreshPermissions();
    }
    setLoading(false);
  }, [refreshPermissions]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    refreshPermissions();
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  // can('billing.view') — admin her zaman yetkili
  const can = useCallback((key) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    const list = Array.isArray(user.permissions) ? user.permissions : (DEFAULT_PERMS[user.role] || []);
    return list.includes(key);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, can, refreshPermissions }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
